import React from "react";
import { HStack, Icon, Spacer, Text, useDisclosure, VStack } from "@chakra-ui/react";
import { CraAttribute } from "@keita/lanepatrol-sdk";
import { IoMdColorWand } from "react-icons/io";
import { CustomTooltip } from "../../../../../../shared/views/CustomTooltip";
import { AttributeInfoModal } from "./AttributeInfoModal";
import { CraAttributeUtils } from "../../../../../../coding/utils/attribute-utils";
import { t } from "i18next";

export const AttributeWrapper = ({
  attributeDefinition,
  label,
  children,
  isSuggested,
  compact,
}: {
  label: string;
  attributeDefinition: CraAttribute;
  showLabel?: boolean;
  children: React.ReactNode;
  isSuggested?: boolean;
  compact: boolean;
}) => {
  const attributeInfoModal = useDisclosure();

const getAttributeInfo = (attributeName: string) => {
  if (attributeName.includes("adjacentFeatures0to1m.")) {
    const subName = attributeName.replace("adjacentFeatures0to1m.", "");
    return t(`sdk:attribute.info.adjacentFeatures.${subName}`);
  }

  if (attributeName.includes("adjacentFeatures1to3m.")) {
    const subName = attributeName.replace("adjacentFeatures1to3m.", "");
    return t(`sdk:attribute.info.adjacentFeatures.${subName}`);
  }

  return CraAttributeUtils.getInfo(attributeName as any);
};

const infoText = getAttributeInfo(attributeDefinition.name);


  const isSuggestedIcon = isSuggested && (
    <CustomTooltip content={"This value has been auto-filled by the system"}>
      <Icon size="md" color="primary.600" as={IoMdColorWand} />
    </CustomTooltip>
  );

  const labelStyles = infoText
    ? { cursor: "pointer", _hover: { textDecoration: "underline" }, onClick: attributeInfoModal.onOpen }
    : {};

  return compact ? (
    <>
      <HStack>
        <HStack width={"180px"} flexShrink={0}>
          <Text fontSize="xs" id={attributeDefinition.name} {...labelStyles}>
            {label}
          </Text>
          <Spacer />
          {isSuggestedIcon}
        </HStack>
        {children}
      </HStack>
      {attributeInfoModal.open && (
        <AttributeInfoModal
          label={label}
          infoText={infoText}
          onClose={attributeInfoModal.onClose}
        />
      )}
    </>
  ) : (
    <VStack>
      <HStack alignItems="center" height={"2.2rem"}>
        <Text fontSize="sm" textAlign="center" id={attributeDefinition.name} {...labelStyles}>
          {label}
        </Text>
        {isSuggestedIcon}
      </HStack>
      {children}
      {attributeInfoModal.open && (
        <AttributeInfoModal
          label={label}
          infoText={infoText}
          onClose={attributeInfoModal.onClose}
        />
      )}
    </VStack>
  );
};